export const setShowProfileHelperInfo = () => {
  localStorage.setItem('showProfileHelperInfo', 'true');
};

export const hasShownProfileHelperInfo = () => {
  return localStorage.getItem('showProfileHelperInfo') === 'true';
};
